import moment from 'moment'
import { currentPricing, golfMemberBenefits, socialMemberBenefits } from '../../docs/memberBenefits'

/**
 * Display details for the add-on plan the API names ({ key: 'golf' | 'social',
 * name, priceId }). Prices and benefits come from docs/memberBenefits.js, as
 * in the primary's renewal popup. Tax is added on top (tax-exclusive prices).
 */
export const planDisplay = (plan) => {
    const isGolf = plan && plan.key === 'golf'
    const pricing = isGolf ? currentPricing.Golf_Addon : currentPricing.Social_Addon
    return {
        name: (plan && plan.name) || (isGolf ? 'Golf Add-on' : 'Social Add-on'),
        price: pricing.amount,
        priceLine: `${pricing.amount} + tax`,
        benefits: isGolf ? golfMemberBenefits : socialMemberBenefits
    }
}

// Term dates are stored as UTC instants on day boundaries; formatting them in
// local time would move a midnight-UTC start to the day before in the US.
export const formatTermDate = (value) => {
    if (!value) { return null }
    const date = moment.utc(value)
    return date.isValid() ? date.format('MMMM D, YYYY') : null
}

export const PAYER_PRIMARY = 'primary'
export const PAYER_SELF = 'self'

// How a self-pay add-on is billed (dashboards-api enroll `billing`): an
// emailed invoice each month, due in 7 days, or the default card charged.
export const BILLING_INVOICE = 'invoice'
export const BILLING_CARD = 'card'

export const primaryLabel = (primaryName) => primaryName || 'your primary member'

/** Where DocuSign sends the iframe when signing ends; see docuSignBridge.js. */
export const bridgeReturnUrl = ({ nonce, sid, renewalId }) =>
    `${window.location.origin}/#/docusign-bridge` +
    `?nonce=${encodeURIComponent(nonce)}` +
    `&sid=${encodeURIComponent(sid)}` +
    `&renewalId=${encodeURIComponent(renewalId)}`
